module.exports = __webpack_public_path__ + "img/time-icon.422e9c1f.svg";